/**
 * Page-specific words inside the shared calculator form card (BirthDetailsForm
 * and its BirthToolFormShell): submit labels, a tool's own time hint, and the
 * input errors a tool shows in the card.
 *
 * Hindi is Devanagari, the same register as the card's own labels in
 * BirthDetailsForm.i18n.ts (owner decision 2026-10-28, replacing the
 * 2026-10-08 Hinglish rule), so one form never mixes scripts (c-forms-10).
 * Guarded by tests/hindi-register.test.ts (hi blocks Devanagari, en blocks
 * free of Devanagari) and tests/calculator-form-register.test.ts.
 */
export const CALCULATOR_FORM_COPY = {
  rashi: {
    en: {
      submit: "Find My Rashi",
      // The shared hint names the Lagna, which a Moon-sign tool never shows.
      timeRequiredHint: "The Moon can change sign within a day — your exact time settles it.",
      timeRequired: "Exact birth time is required to calculate Moon sign and nakshatra.",
      placeRequired: "Select a birth city from the suggestions to calculate its coordinates.",
      failed: "Something went wrong",
      // The result reserve under the card repeats the error beside this button.
      calculating: "Calculating your Moon sign…",
      editDetails: "Edit birth details",
    },
    hi: {
      submit: "अपनी राशि देखें",
      timeRequiredHint: "चंद्रमा एक दिन में राशि बदल सकता है — सही समय से पक्की राशि मिलती है।",
      timeRequired: "चंद्र राशि और नक्षत्र के लिए सही जन्म समय ज़रूरी है।",
      placeRequired: "सटीक निर्देशांक के लिए सुझावों में से जन्म स्थान चुनें।",
      failed: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
      calculating: "आपकी चंद्र राशि की गणना हो रही है…",
      editDetails: "जन्म विवरण बदलें",
    },
  },
  ascendant: {
    en: { submit: "Find My Ascendant", failed: "Something went wrong" },
    hi: {
      submit: "अपना लग्न देखें",
      failed: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
    },
  },
  nakshatra: {
    en: { submit: "Find My Nakshatra", failed: "Something went wrong" },
    hi: {
      submit: "अपना नक्षत्र देखें",
      failed: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
    },
  },
  remedies: {
    en: { submit: "Check My Remedies", failed: "Something went wrong" },
    hi: {
      submit: "अपने उपाय देखें",
      failed: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
    },
  },
} as const;
